import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Button } from "@oc-labs/wt-storybook";

export default function SortByModal({
    isOpen,
    closeModal,
    selectedSort,
    setSelectedSort,
}) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <div className="fixed inset-0 backdrop-brightness-75" />

                <div className="fixed inset-0 flex items-center justify-center">
                    <Dialog.Panel className="w-full max-w-xs bg-white rounded-2xl shadow-lg p-4">
                        <div className="flex justify-between items-center mb-8">
                            <Dialog.Title className="text-lg font-semibold">
                                Sort by
                            </Dialog.Title>

                            <div>
                                <Button
                                    size="small"
                                    type="tertiary"
                                    icon="✕"
                                    onClick={closeModal}
                                />
                            </div>
                        </div>

                        <div className="space-y-8">
                            <label className="flex justify-between items-center cursor-pointer">
                                <span className="text-sm">A-Z</span>
                                <input
                                    type="radio"
                                    name="sort"
                                    value="A-Z"
                                    checked={selectedSort === "A-Z"}
                                    onChange={() => setSelectedSort("A-Z")}
                                    className="w-5 h-5 text-blue-600"
                                />
                            </label>

                            <label className="flex justify-between items-center cursor-pointer">
                                <span className="text-sm">
                                    New members
                                </span>

                                <input
                                    type="radio"
                                    name="sort"
                                    value="New members"
                                    checked={selectedSort === "New members"}
                                    onChange={() => setSelectedSort("New members")}
                                    className="w-5 h-5 text-blue-600"
                                />
                            </label>
                        </div>

                        <div className="mt-8">
                            <Button
                                type="primary"
                                onClick={closeModal}
                                className="mt-6"
                            >
                                Show result
                            </Button>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </Transition>
    );
}
